import { render, staticRenderFns } from "./RipaSubmissionsGrid.vue?vue&type=template&id=56e81137"
import script from "./RipaSubmissionsGrid.vue?vue&type=script&lang=js"
export * from "./RipaSubmissionsGrid.vue?vue&type=script&lang=js"
import style0 from "./RipaSubmissionsGrid.vue?vue&type=style&index=0&id=56e81137&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports